import { Sparkles } from "lucide-react";

const ITEMS = ["Sports", "Sisterhood", "Leadership", "Money", "Confidence", "School", "Life"];

const Row = ({ hidden = false }) => (
  <div className="flex items-center shrink-0" aria-hidden={hidden || undefined}>
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center shrink-0">
        <span className="font-display text-xl sm:text-3xl font-extrabold uppercase tracking-tight text-purple-900/50 whitespace-nowrap px-6 sm:px-10">
          {item}
        </span>
        <Sparkles className="w-5 h-5 text-purple-500 shrink-0" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    className="marquee relative border-y border-purple-100 bg-gradient-to-r from-lavender-50 via-lavender-100 to-lavender-50 py-5 overflow-hidden"
    data-testid="marquee"
  >
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);

export default Marquee;